class TabsFilter extends HTMLElement {
    constructor() {
      super();
      this.filters = document.querySelectorAll('tabs-filter');
      this.makers = document.querySelectorAll('.makers-grid__item');
      this.makers.forEach((tab, index) => {
        if (index !== 0) {
          tab.classList.add('hidden');
        }
      });
      this.addEventListener('click', this.onClick.bind(this))
    }
  
    onClick(){
      this.filters.forEach(filter => {
        filter.classList.remove('active')
      })
      this.classList.add('active');
  
      this.makers.forEach(maker => {
        maker.classList.remove('hidden')
      })

      let filterOption = this.getAttribute('data-filter-option');
        this.makers.forEach(maker => {
          if (maker.getAttribute('data-filter') != filterOption) {
            maker.classList.add('hidden') 
          }
        })
  
    }
 
  }
  
  customElements.define('tabs-filter', TabsFilter);